export default{
  winner_list : [
    {
      "Rank": 1,
      "PlayerId": "******3031",
      "DisplayName": "Azzra3031",
      "TranTs": 1652771410,
      "CurrencyCode": "MYR",
      "GameCode": "3800",
      "GameName": "Tiger Clash Cash",
      "BetAmount": 20,
      "ReturnAmount": 6536
    },
    {
      "Rank": 2,
      "PlayerId": "******6370",
      "DisplayName": "KETAK",
      "TranTs": 1650832965,
      "CurrencyCode": "MYR",
      "GameCode": "10600",
      "GameName": "Jiang Zi Ya",
      "BetAmount": 50,
      "ReturnAmount": 5655
    },
    {
      "Rank": 3,
      "PlayerId": "******7807",
      "DisplayName": "Rafdzi",
      "TranTs": 1650893548,
      "CurrencyCode": "MYR",
      "GameCode": "9100",
      "GameName": "Venom 2",
      "BetAmount": 5,
      "ReturnAmount": 5580.5
    },
    {
      "Rank": 4,
      "PlayerId": "******3833",
      "DisplayName": "koloitiger",
      "TranTs": 1653313490,
      "CurrencyCode": "MYR",
      "GameCode": "840034",
      "GameName": "Amazing Money Machine",
      "BetAmount": 1,
      "ReturnAmount": 5076.75
    },
    {
      "Rank": 5,
      "PlayerId": "******7387",
      "DisplayName": "ericjian",
      "TranTs": 1652738292,
      "CurrencyCode": "MYR",
      "GameCode": "840009",
      "GameName": "Starlight Princess",
      "BetAmount": 5,
      "ReturnAmount": 5061
    },
    {
      "Rank": 6,
      "PlayerId": "******5517",
      "DisplayName": "RyanLim",
      "TranTs": 1652573839,
      "CurrencyCode": "MYR",
      "GameCode": "400",
      "GameName": "Man Of Steel 7",
      "BetAmount": 10,
      "ReturnAmount": 5000
    },
    {
      "Rank": 7,
      "PlayerId": "******2095",
      "DisplayName": "Alexsss",
      "TranTs": 1651743313,
      "CurrencyCode": "MYR",
      "GameCode": "7900",
      "GameName": "AI City",
      "BetAmount": 10,
      "ReturnAmount": 4750
    },
    {
      "Rank": 8,
      "PlayerId": "******7131",
      "DisplayName": "cotarika",
      "TranTs": 1652645109,
      "CurrencyCode": "MYR",
      "GameCode": "8600",
      "GameName": "Epic Great Blue",
      "BetAmount": 3.5,
      "ReturnAmount": 4748.1
    },
    {
      "Rank": 9,
      "PlayerId": "******8886",
      "DisplayName": "Khaeryll",
      "TranTs": 1652701299,
      "CurrencyCode": "MYR",
      "GameCode": "8600",
      "GameName": "Epic Great Blue",
      "BetAmount": 1,
      "ReturnAmount": 4462.2
    },
    {
      "Rank": 10,
      "PlayerId": "******5120",
      "DisplayName": "orangMinyak83",
      "TranTs": 1651876163,
      "CurrencyCode": "MYR",
      "GameCode": "10800",
      "GameName": "Riches Of Tiger",
      "BetAmount": 15.2,
      "ReturnAmount": 4290.4
    }
  ]
}